import React, { useState } from 'react'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'

import QuotationReportList from './QuotationReportList'

const QuotationReport = () => {
        const [searchUi, setSearchUi] = useState(false)
        const [searchData, setSearchData] = useState(null)

  return (
       <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<QuotationReportList/>}
                menuId={10}
            />
        </DataContext.Provider>
  )
}

export default QuotationReport